module.exports = __webpack_public_path__ + "static/media/CS 06 Day 7 015.80b54fa8.jpg";